import { PATH } from './constants/router'
import TrafficViolationsLookup from './page/TrafficViolationsLookup'
import TrafficViolationsResult from './page/TrafficViolationsResult'

export const ROUTERS = {
  home: {
    path: PATH.HOME,
    component: TrafficViolationsLookup
  },
  trafficViolationsLookup: {
    path: PATH.TRAFFIC_VIOLATIONS_LOOKUP,
    component: TrafficViolationsLookup
  },
  trafficViolationsResult: {
    path: PATH.TRAFFIC_VIOLATIONS_RESULT,
    component: TrafficViolationsResult
  }
}
